module.exports = __webpack_public_path__ + "images/stickers/pete-completed@2x.da6d88c5ef2043139a85.png";